import React, { useState, useEffect, use } from 'react';
import { NavLink, useParams, useNavigate} from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from './../../Auth/apiService.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import { savePermisosPaginas, getPermisosPaginas } from './../Utils/indexedDBUtils';
import { Card, CardBody, CardHeader } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

export default function GenerarDxSemana(){
    const navigate = useNavigate();    
    const { id } = useParams();
    const { token, rol, user, fetchPermisosPaginas } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [swalProps, setSwalProps] = useState();
    const [permisosPaginas, setPermisosPaginas] = useState([]);
    const { control, handleSubmit, register, setValue, getValues, watch, formState: { errors }} = useForm({
        defaultValues: {
            id: id || '0',
            fechas: {prevStart: '', prevEnd: '', currStart: '', currEnd: '',},
            fechaSemanaActual: '',
            datosPaginaTres: {},
            datosPaginaCuatro: {},
            datosPaginaCinco: {},
            datosPaginaSeis: {},
            datosPaginaSeisB: {},
            datosPaginaSiete: {},
            datosPaginaOcho: {},
            datosPaginaOchoB: {},
            datosPaginaDiez: {
                textoResumen: '',
            },
            datosPaginaOnce: {
                subtitulo: '',
                textoResumen: '',
            },
            datosPaginaDoce: {
                subtitulo: '',
                textoResumen: '',
            },
        }
    });
    const [prevStart, setPrevStart] = useState('');
    const [prevEnd, setPrevEnd] = useState('');
    const [currStart, setCurrStart] = useState('');
    const [currEnd, setCurrEnd] = useState('');

    const consultarPermisosPaginas = React.useCallback(async () => {
        const cachedPermisos = await getPermisosPaginas();
        if (cachedPermisos) {
            setPermisosPaginas(cachedPermisos);
        } else {
            // If not in IndexedDB, fetch from the API
            const permisos = await fetchPermisosPaginas();
            if (permisos) {
                setPermisosPaginas(permisos);
                await savePermisosPaginas(permisos); // Save the result to IndexedDB
            }
        }
    }, [fetchPermisosPaginas]);

    useEffect(() => {
        consultarPermisosPaginas();
    }, [consultarPermisosPaginas]);

    // Initialize sensible default date ranges:
    useEffect(() => {
        // helper to format yyyy-mm-dd
        const fmt = (d) => d.toISOString().slice(0,10);

        const today = new Date();
        // Current week: last 7 days ending today (currStart .. currEnd)
        const currEndDate = new Date(today);
        const currStartDate = new Date(today);
        currStartDate.setDate(currEndDate.getDate() - 6);

        // Previous week: the 7 days preceding the current week (prevStart .. prevEnd)
        const prevEndDate = new Date(currStartDate);
        prevEndDate.setDate(currStartDate.getDate() - 1);
        const prevStartDate = new Date(prevEndDate);
        prevStartDate.setDate(prevEndDate.getDate() - 6);

        // Only set defaults if not already set by user
        setPrevStart((v) => v || fmt(prevStartDate));
        setPrevEnd((v) => v || fmt(prevEndDate));
        setCurrStart((v) => v || fmt(currStartDate));
        setCurrEnd((v) => v || fmt(currEndDate));
    }, []);

    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };

    async function fetchReporteSemana(prevStart, prevEnd, currStart, currEnd) {
        setCargando(true);
        if (!prevStart || !prevEnd || !currStart || !currEnd) {
            Mensaje('Fechas incompletas', 'Por favor complete las cuatro fechas antes de generar el reporte.');
            return;
        }
        const url = '/diagnostico/reportes/generarreportesemanal'; 
        await apiService.post(url, {
                prevStart,
                prevEnd,
                currStart,
                currEnd
            }, token)
        .then((response) => {
            const result = response.data;
            setValue('fechas', {prevStart, prevEnd, currStart, currEnd});
            setValue('fechaSemanaActual', result.fechaSemanaActual);
            setValue('datosPaginaTres', result.datosPaginaTres);
            setValue('datosPaginaCuatro', result.datosPaginaCuatro);
            setValue('datosPaginaCinco', result.datosPaginaCinco);
            setValue('datosPaginaSeis', result.datosPaginaSeis);
            setValue('datosPaginaSeisB', result.datosPaginaSeisB);
            setValue('datosPaginaSiete', result.datosPaginaSiete);
            setValue('datosPaginaOcho', result.datosPaginaOcho);
            setValue('datosPaginaOchoB', result.datosPaginaOchoB);
            setValue('datosPaginaDiez', result.datosPaginaDiez);
            setValue('datosPaginaOnce', result.datosPaginaOnce);
            setValue('datosPaginaDoce', result.datosPaginaDoce);
        })
        .catch((error) => {
            console.error('Error fetching weekly report:', error);
            Mensaje('Error', 'Hubo un error al generar el reporte semanal.');
        })
        .finally(() => {
            setCargando(false);
        });
    }

    useEffect(() => {
        async function fetchReporte(id) {
            if (id !== '0') {
            setCargando(true);
            await apiService.get('/diagnostico/reportesemanal/obtenerreporte/' + id, token)
            .then((response) => {
                if (response.status === 200) {
                    const result = response.data;
                    setValue('fechas', {prevStart, prevEnd, currStart, currEnd});
                    setValue('fechaSemanaActual', result.fechaSemanaActual);
                    setValue('datosPaginaTres', result.datosPaginaTres);
                    setValue('datosPaginaCuatro', result.datosPaginaCuatro);
                    setValue('datosPaginaCinco', result.datosPaginaCinco);
                    setValue('datosPaginaSeis', result.datosPaginaSeis);
                    setValue('datosPaginaSeisB', result.datosPaginaSeisB);
                    setValue('datosPaginaSiete', result.datosPaginaSiete);
                    setValue('datosPaginaOcho', result.datosPaginaOcho);
                    setValue('datosPaginaOchoB', result.datosPaginaOchoB);
                    setValue('datosPaginaDiez', result.datosPaginaDiez);
                    setValue('datosPaginaOnce', result.datosPaginaOnce);
                    setValue('datosPaginaDoce', result.datosPaginaDoce);
                    setCargando(false);
                } else {
                    Mensaje('Error', 'No se pudo obtener el reporte solicitado.');
                    setCargando(false);
                }
            })
            .catch((error) => {
                Mensaje('Error', 'No se pudo obtener el reporte solicitado.');
                setCargando(false);
            });
        }
        }
        fetchReporte(id);
    }, [id]);

    const onSubmit = async (data) => {
        setCargando(true);
        const url = '/diagnostico/reportes/guardarreportesemanal';
        data.fechas.currStart = currStart;
        data.fechas.currEnd = currEnd;
        data.fechas.prevStart = prevStart;
        data.fechas.prevEnd = prevEnd;
        await apiService.post(url, data, token)
        .then((response) => {
            Mensaje('Éxito', 'El reporte semanal ha sido guardado correctamente.' + response.data.message + ' id:' + response.data.id);
        })
        .catch((error) => {
            console.error('Error saving weekly report:', error);
            Mensaje('Error', 'Hubo un error al guardar el reporte semanal.');
        })
        .finally(() => {
            setCargando(false);
        });
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Generar reporte semanal</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><NavLink to="/caracterizacion/reportes" > Reportes</NavLink></li>
                                <li className="breadcrumb-item active"> Generar reporte semanal</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                    </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {id && id === '0' && <Card>
                        <CardHeader>
                            <h3 className="card-title">Generar reporte semanal</h3>
                        </CardHeader>
                        <CardBody>
                            <div className="row">
                                <div className="col-md-6">
                                    <h5>Semana anterior</h5>
                                    <div className="form-group">
                                        <label>Fecha inicio</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={prevStart}
                                            onChange={(e) => setPrevStart(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Fecha fin</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={prevEnd}
                                            onChange={(e) => setPrevEnd(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <h5>Semana actual</h5>
                                    <div className="form-group">
                                        <label>Fecha inicio</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={currStart}
                                            onChange={(e) => setCurrStart(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Fecha fin</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={currEnd}
                                            onChange={(e) => setCurrEnd(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: 12 }}>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        fetchReporteSemana(prevStart, prevEnd, currStart, currEnd);
                                    }}
                                >
                                    Aplicar rangos
                                </button>
                            </div>
                        </CardBody>
                    </Card>}
                    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                        <input type="hidden" {...register('id')} />
                        {getValues('fechaSemanaActual') && <Card style={{ marginTop: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina tres</h3>
                            </CardHeader>
                            <CardBody>
                                {(() => {
                                    const d = watch('datosPaginaTres') || {};
                                    const toNum = (v) => {
                                        if (v === undefined || v === null || v === '') return NaN;
                                        const s = String(v).replace(/[^\d.-]/g, '');
                                        return s === '' ? NaN : Number(s);
                                    };
                                    const hAnioA = toNum(d.hogaresAnioActual);
                                    const hAnioB = toNum(d.hogaresAnioAnterior);
                                    const hSemA = toNum(d.hogaresSemanaActual);
                                    const hSemB = toNum(d.hogaresSemanaAnterior);
                                    const pAnioA = toNum(d.personasAnioActual);
                                    const pAnioB = toNum(d.personasAnioAnterior);
                                    const pSemA = toNum(d.personasSemanaActual);
                                    const pSemB = toNum(d.personasSemanaAnterior);
                                    const pct = (a, b) => (isNaN(a) || isNaN(b) || b === 0) ? '-' : (((a - b) / b * 100).toFixed(1) + '%');

                                    return (
                                        <div>
                                            <p><strong>{d.fechaSemanaActual || '-'}</strong></p>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <h6>Hogares</h6>
                                                    <ul className="list-unstyled">
                                                        <li>Año actual: {isNaN(hAnioA) ? '-' : hAnioA.toLocaleString()}</li>
                                                        <li>Año anterior: {isNaN(hAnioB) ? '-' : hAnioB.toLocaleString()}</li>
                                                        <li>Semana actual: {isNaN(hSemA) ? '-' : hSemA.toLocaleString()}</li>
                                                        <li>Semana anterior: {isNaN(hSemB) ? '-' : hSemB.toLocaleString()}</li>
                                                        <li>Cambio anual: {pct(hAnioA, hAnioB)}</li>
                                                        <li>Cambio semanal: {isNaN(hSemA) || isNaN(hSemB) || hSemB === 0 ? '-' : (((hSemA - hSemB) / hSemB * 100).toFixed(1) + '%')}</li>
                                                    </ul>
                                                </div>

                                                <div className="col-md-6">
                                                    <h6>Personas</h6>
                                                    <ul className="list-unstyled">
                                                        <li>Año actual: {isNaN(pAnioA) ? '-' : pAnioA.toLocaleString()}</li>
                                                        <li>Año anterior: {isNaN(pAnioB) ? '-' : pAnioB.toLocaleString()}</li>
                                                        <li>Semana actual: {isNaN(pSemA) ? '-' : pSemA.toLocaleString()}</li>
                                                        <li>Semana anterior: {isNaN(pSemB) ? '-' : pSemB.toLocaleString()}</li>
                                                        <li>Cambio anual: {pct(pAnioA, pAnioB)}</li>
                                                        <li>Cambio semanal: {isNaN(pSemA) || isNaN(pSemB) || pSemB === 0 ? '-' : (((pSemA - pSemB) / pSemB * 100).toFixed(1) + '%')}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginTop: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina cuatro</h3>
                            </CardHeader>
                            <CardBody>
                                {(() => {
                                    const d = watch('datosPaginaCuatro') || {};
                                    // rows might be provided as an array directly or as d.rows / d.data
                                    const rows = Array.isArray(d)
                                        ? d
                                        : Array.isArray(d.rows)
                                        ? d.rows
                                        : Array.isArray(d.data)
                                        ? d.data
                                        : Array.isArray(d.municipios)
                                        ? d.municipios
                                        : [];

                                    const totalRecibidosFueraMed = d.totalRecibidosFueraMed ?? d.totalRecibidosFueraMedinos ?? d.totalRecibidosFuera ?? null;
                                    const totalRecibidosMed = d.totalRecibidosMed ?? d.totalRecibidosMedinos ?? d.totalRecibidos ?? null;

                                    return (
                                        <div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                                <div>
                                                    <strong>Total recibidos (Medellín): </strong>{totalRecibidosMed != null ? String(totalRecibidosMed).toLocaleString() : '-'}
                                                    &nbsp;&nbsp;
                                                    <strong>Total recibidos (fuera Medellín): </strong>{totalRecibidosFueraMed != null ? String(totalRecibidosFueraMed).toLocaleString() : '-'}
                                                </div>
                                            </div>

                                            {rows.length ? (
                                                <div style={{ overflowX: 'auto' }}>
                                                    <table className="table table-sm table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ minWidth: 120 }}>Municipio</th>
                                                                <th style={{ minWidth: 140 }}>Subregión</th>
                                                                <th style={{ textAlign: 'right', minWidth: 120 }}>Total Hogares</th>
                                                                <th style={{ textAlign: 'right', minWidth: 120 }}>Total Personas</th>
                                                                <th style={{ textAlign: 'right', minWidth: 120 }}>Porcentaje</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {rows.map((r, idx) => {
                                                                const totalH = r.totalHogares ?? r.total_hogares ?? r.totalHogar ?? r.total ?? 0;
                                                                const totalP = r.totalPersonas ?? r.total_personas ?? r.personas ?? r.totalPersonasAtendidas ?? '';
                                                                const pct = r.porcentaje ?? r.porcent ?? r.porcentajes ?? '';
                                                                return (
                                                                    <tr key={`${r.idMunicipio ?? r.municipio ?? 'municipio'}-${idx}`}>
                                                                        <td>{r.municipio ?? r.Municipio ?? '-'}</td>
                                                                        <td>{r.subregion ?? r.Subregion ?? '-'}</td>
                                                                        <td style={{ textAlign: 'right' }}>{(totalH === '' || totalH === null || typeof totalH === 'undefined') ? '-' : Number(totalH).toLocaleString()}</td>
                                                                        <td style={{ textAlign: 'right' }}>{(totalP === '' || totalP === null || typeof totalP === 'undefined') ? '-' : String(totalP)}</td>
                                                                        <td style={{ textAlign: 'right' }}>{pct ?? '-'}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <p>No hay datos para mostrar en la página cuatro.</p>
                                            )}
                                        </div>
                                    );
                                })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginTop: 20, marginBottom: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina cinco</h3>
                            </CardHeader>
                            <CardBody>
                                {(() => {
                                    const d = watch('datosPaginaCinco') || {};
                                    // rows might be an array or under several keys (rows, data, municipios, etc.)
                                    const rows = Array.isArray(d)
                                        ? d
                                        : Array.isArray(d.rows)
                                        ? d.rows
                                        : Array.isArray(d.data)
                                        ? d.data
                                        : Array.isArray(d.municipios)
                                        ? d.municipios
                                        : Array.isArray(d.departamentos)
                                        ? d.departamentos
                                        : [];

                                    const totalOtrosDepartamentos = d.totalOtrosDepartamentos ?? d.total_otros_departamentos ?? d.totalOtrosDept ?? d.totalOtros ?? null;

                                    return (
                                        <div>
                                            <div style={{ marginBottom: 12 }}>
                                                <strong>Total otros departamentos: </strong>{totalOtrosDepartamentos != null ? String(totalOtrosDepartamentos).toLocaleString() : '-'}
                                            </div>

                                            {rows.length ? (
                                                <div style={{ overflowX: 'auto' }}>
                                                    <table className="table table-sm table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ minWidth: 100 }}>Código Dept</th>
                                                                <th style={{ minWidth: 200 }}>Departamento</th>
                                                                <th style={{ textAlign: 'right', minWidth: 140 }}>Hogares</th>
                                                                <th style={{ textAlign: 'right', minWidth: 140 }}>Personas</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {rows.map((r, idx) => {
                                                                const cod = r.cod_dept ?? r.codDept ?? r.codigo ?? '';
                                                                const dept = r.departamento ?? r.Departamento ?? r.depto ?? '';
                                                                const hogares = r.hogares_count ?? r.hogaresCount ?? r.hogares ?? r.totalHogares ?? 0;
                                                                const personas = r.total_personas ?? r.totalPersonas ?? r.personas ?? 0;
                                                                return (
                                                                    <tr key={`${cod || dept || 'departamento'}-${idx}`}>
                                                                        <td>{cod}</td>
                                                                        <td>{dept || '-'}</td>
                                                                        <td style={{ textAlign: 'right' }}>{(hogares === '' || hogares === null || typeof hogares === 'undefined') ? '-' : Number(hogares).toLocaleString()}</td>
                                                                        <td style={{ textAlign: 'right' }}>{(personas === '' || personas === null || typeof personas === 'undefined') ? '-' : Number(personas).toLocaleString()}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <p>No hay datos para mostrar en la página cinco.</p>
                                            )}
                                        </div>
                                    );
                                })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginBottom: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina seis</h3>
                            </CardHeader>
                            <CardBody>
                                {(() => {
                                    const d = watch('datosPaginaSeis') || {};
                                    // Defensive extraction similar to pagina siete example
                                    const etnias = Array.isArray(d.etnias)
                                        ? d.etnias
                                        : Array.isArray(d.etnia)
                                        ? d.etnia
                                        : Array.isArray(d.rows)
                                        ? d.rows
                                        : Array.isArray(d.data)
                                        ? d.data
                                        : [];

                                    const porDepartamento = Array.isArray(d.porDepartamento)
                                        ? d.porDepartamento
                                        : Array.isArray(d.por_departamento)
                                        ? d.por_departamento
                                        : Array.isArray(d.byDepartment)
                                        ? d.byDepartment
                                        : Array.isArray(d.por_departamento_detalle)
                                        ? d.por_departamento_detalle
                                        : [];

                                    const sumCount = (arr) => arr.reduce((s, r) => {
                                        const n = Number(r.count ?? r.cantidad ?? r.total ?? r.count ?? 0) || 0;
                                        return s + n;
                                    }, 0);

                                    const totalEtnias = sumCount(etnias);
                                    const totalPorDept = sumCount(porDepartamento);

                                    return (
                                        <div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                                <div><strong>Registros etnias:</strong> {etnias.length}</div>
                                                <div><strong>Total etnias (suma de counts):</strong> {totalEtnias.toLocaleString()}</div>
                                            </div>

                                            {etnias.length ? (
                                                <div style={{ overflowX: 'auto', marginBottom: 12 }}>
                                                    <table className="table table-sm table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ minWidth: 80 }}>Etnia</th>
                                                                <th style={{ minWidth: 180 }}>Min. / Et. texto</th>
                                                                <th style={{ textAlign: 'right', minWidth: 120 }}>Count</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {etnias.map((r, i) => {
                                                                const etniaCode = r.etnia ?? r.etnia_id ?? r.id ?? '';
                                                                const minTxt = r.min_minoria ?? r.min_minoria_text ?? r.minoria ?? r.min ?? (r.name ?? '');
                                                                const cnt = Number(r.count ?? r.cantidad ?? r.total ?? 0) || 0;
                                                                return (
                                                                    <tr key={`${r.etnia ?? r.id ?? 'etnia'}-${i}`}>
                                                                        <td>{String(etniaCode)}</td>
                                                                        <td>{minTxt ?? '-'}</td>
                                                                        <td style={{ textAlign: 'right' }}>{cnt.toLocaleString()}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <p>No hay datos de etnias para mostrar.</p>
                                            )}

                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                                <div><strong>Registros por departamento:</strong> {porDepartamento.length}</div>
                                                <div><strong>Total por departamento (suma de counts):</strong> {totalPorDept.toLocaleString()}</div>
                                            </div>

                                            {porDepartamento.length ? (
                                                <div style={{ overflowX: 'auto' }}>
                                                    <table className="table table-sm table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ minWidth: 180 }}>Departamento</th>
                                                                <th style={{ minWidth: 80 }}>Etnia</th>
                                                                <th style={{ minWidth: 180 }}>Min. / Et. texto</th>
                                                                <th style={{ textAlign: 'right', minWidth: 120 }}>Count</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {porDepartamento.map((r, i) => {
                                                                const dept = r.departamento ?? r.Departamento ?? r.depto ?? r.region ?? '';
                                                                const etniaCode = r.etnia ?? r.etnia_id ?? '';
                                                                const minTxt = r.min_minoria ?? r.min_minoria_text ?? r.minoria ?? '';
                                                                const cnt = Number(r.count ?? r.cantidad ?? r.total ?? 0) || 0;
                                                                return (
                                                                    <tr key={`${dept}-${etniaCode}-${i}`}>
                                                                        <td>{dept || '-'}</td>
                                                                        <td>{String(etniaCode)}</td>
                                                                        <td>{minTxt ?? '-'}</td>
                                                                        <td style={{ textAlign: 'right' }}>{cnt.toLocaleString()}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <p>No hay datos por departamento para mostrar.</p>
                                            )}
                                        </div>
                                    );
                                })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginTop: 20 }}>
                            <CardHeader>
                            <h3 className="card-title">Datos pagina seis diferenciales</h3>
                            </CardHeader>
                            <CardBody>
                            {(() => {
                                const d = watch('datosPaginaSeisB') || {};
                                console.log('Datos página seis diferenciales:', d);
                                const graf1 = Array.isArray(d.graficaUnoData)
                                ? d.graficaUnoData
                                : [];

                                const graf2 = Array.isArray(d.graficaDosData)
                                ? d.graficaDosData
                                : [];

                                const graf3 = Array.isArray(d.graficaTresData)
                                ? d.graficaTresData
                                : [];

                                const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return 0;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? 0 : Number(s);
                                };

                                const total1 = graf1.reduce((acc, r) => acc + toNum(r.total), 0);

                                const pct = (val, tot) => {
                                if (tot === 0) return '-';
                                return ((toNum(val) / tot) * 100).toFixed(1) + '%';
                                };

                                return (
                                <div>
                                    <div className="form-group">
                                    <label>Texto Cualitativo 1</label>
                                    <textarea
                                        className="form-control"
                                        rows={2}
                                        {...register('datosPaginaSeisB.textoCualitativo')}
                                        placeholder="Ej: 53.7% de las personas atendidas provenientes de otros municipios fueron mujeres."
                                    />
                                    </div>

                                    <div className="form-group">
                                    <label>Texto Cualitativo 2</label>
                                    <textarea
                                        className="form-control"
                                        rows={2}
                                        {...register('datosPaginaSeisB.textoCualitativoDos')}
                                        placeholder="Ej: Los NNAJ con edades entre los 0 y los 17 años..."
                                    />
                                    </div>

                                    <div className="form-group">
                                    <label>Texto Cualitativo 3</label>
                                    <textarea
                                        className="form-control"
                                        rows={2}
                                        {...register('datosPaginaSeisB.textoCualitativoTres')}
                                        placeholder="Ej: Las personas de edades entre los 26 a 59 años..."
                                    />
                                    </div>

                                    <div className="form-group">
                                    <label>Texto Cualitativo 4</label>
                                    <textarea
                                        className="form-control"
                                        rows={2}
                                        {...register('datosPaginaSeisB.textoCualitativoCuatro')}
                                        placeholder="Ej: 1 persona que se reconoció como población OSIEGD fue atendida."
                                    />
                                    </div>

                                    <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                                    <div style={{ flex: 1 }}>
                                        <h6>Gráfica 1 — Personas por Sexo</h6>
                                        {graf1.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table table-sm table-striped">
                                            <thead>
                                                <tr>
                                                <th>Sexo</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                <th style={{ textAlign: 'right' }}>%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {graf1
                                                .slice()
                                                .sort((a, b) => toNum(b.total) - toNum(a.total))
                                                .map((r, i) => (
                                                    <tr key={`${r.categoria}-${i}`}>
                                                    <td>{String(r.categoria ?? '-')}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        {toNum(r.total) === 0 ? '-' : toNum(r.total).toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{pct(r.total, total1)}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                <td colSpan={1}><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}><strong>{total1.toLocaleString()}</strong></td>
                                                <td />
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                        ) : (
                                        <p>No hay datos para la gráfica 1.</p>
                                        )}
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <h6>Gráfica 2 — Personas por Grupo Etario y Sexo</h6>
                                        {graf2.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table table-sm table-striped">
                                            <thead>
                                                <tr>
                                                <th>Grupo Etario</th>
                                                <th style={{ textAlign: 'right' }}>Hombres</th>
                                                <th style={{ textAlign: 'right' }}>%Hombres</th>
                                                <th style={{ textAlign: 'right' }}>Mujeres</th>
                                                <th style={{ textAlign: 'right' }}>%Mujeres</th>
                                                <th style={{ textAlign: 'right' }}>Intersexual</th>
                                                <th style={{ textAlign: 'right' }}>%Intersexual</th>
                                                <th style={{ textAlign: 'right' }}>Indefinido</th>
                                                <th style={{ textAlign: 'right' }}>%Indefinido</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {graf2.map((r, i) => {
                                                const h = toNum(r.hombres);
                                                const pctH = toNum(r.porcentajeHombres)
                                                const m = toNum(r.mujeres);
                                                const pctM = toNum(r.porcentajeMujeres)
                                                const inter = toNum(r.intersexual);
                                                const pctInter = toNum(r.porcentajeIntersexual)
                                                const indef = toNum(r.indefinido);
                                                const pctIndef = toNum(r.porcentajeIndefinido)
                                                const rowTotal = h + m + inter + indef;
                                                
                                                const displayLabel = String(r.grupoetareo ?? r.categoria ?? '-')
                                                    .replace('de_', '')
                                                    .replace(/_/g, ' ')
                                                    .replace('anios', 'años')
                                                    .replace('0 mas', '0 o más');

                                                return (
                                                    <tr key={r.grupoetareo ?? r.categoria ?? i}>
                                                    <td>{displayLabel}</td>
                                                    <td style={{ textAlign: 'right' }}>{h || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{pctH || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{m || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{pctM || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{inter || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{pctInter || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{indef || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{pctIndef || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}><strong>{rowTotal}</strong></td>
                                                    </tr>
                                                );
                                                })}
                                                <tr>
                                                <td><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}>
                                                    <strong>{graf2.reduce((acc, r) => acc + toNum(r.hombres), 0)}</strong>
                                                </td>
                                                <td />
                                                <td style={{ textAlign: 'right' }}>
                                                    <strong>{graf2.reduce((acc, r) => acc + toNum(r.mujeres), 0)}</strong>
                                                </td>
                                                <td />
                                                <td style={{ textAlign: 'right' }}>
                                                    <strong>{graf2.reduce((acc, r) => acc + toNum(r.intersexual), 0)}</strong>
                                                </td>
                                                <td />
                                                <td style={{ textAlign: 'right' }}>
                                                    <strong>{graf2.reduce((acc, r) => acc + toNum(r.indefinido), 0)}</strong>
                                                </td>
                                                <td />
                                                <td style={{ textAlign: 'right' }}>
                                                    <strong>
                                                    {graf2.reduce((acc, r) => 
                                                        acc + toNum(r.hombres) + toNum(r.mujeres) + toNum(r.intersexual) + toNum(r.indefinido), 0
                                                    )}
                                                    </strong>
                                                </td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                        ) : (
                                        <p>No hay datos para la gráfica 2.</p>
                                        )}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <h6>Gráfica 3 — Personas por Población OSIEGD</h6>
                                        {graf3.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table table-sm table-striped">
                                            <thead>
                                                <tr>
                                                <th>Población OSIEGD</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                <th style={{ textAlign: 'right' }}>%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {graf3.map((r, i) => (
                                                    <tr key={`${r.categoria}-${i}`}>
                                                    <td>{String(r.categoria ?? '-')}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        {toNum(r.total) === 0 ? '-' : toNum(r.total).toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{pct(r.total, total1)}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                <td><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}><strong>{total1.toLocaleString()}</strong></td>
                                                <td />
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                        ) : (
                                        <p>No hay datos para la gráfica 3.</p>
                                        )}
                                      </div>  
                                    </div>
                                </div>
                                );
                            })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginBottom: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina siete</h3>
                            </CardHeader>
                            <CardBody>
                                {(() => {
                                    const d = watch('datosPaginaSiete') || {};
                                    const toNum = (v) => {
                                    if (v === undefined || v === null || v === '') return NaN;
                                    const s = String(v).replace(/[^\d.-]/g, '');
                                    return s === '' ? NaN : Number(s);
                                    };
                                    const hAnioA = toNum(d.hogaresAnioActual);
                                    const hAnioB = toNum(d.hogaresAnioAnterior);
                                    const hSemA = toNum(d.hogaresSemanaActual);
                                    const hSemB = toNum(d.hogaresSemanaAnterior);
                                    const pAnioA = toNum(d.personasAnioActual);
                                    const pAnioB = toNum(d.personasAnioAnterior);
                                    const pSemA = toNum(d.personasSemanaActual);
                                    const pSemB = toNum(d.personasSemanaAnterior);
                                    const pct = (a, b) => (isNaN(a) || isNaN(b) || b === 0) ? '-' : (((a - b) / b * 100).toFixed(1) + '%');

                                    return (
                                    <div>
                                        <p><strong>Intraurbanos</strong></p>

                                        <div className="row">
                                        <div className="col-md-6">
                                            <h6>Hogares</h6>
                                            <ul className="list-unstyled">
                                            <li>Año actual: {isNaN(hAnioA) ? '-' : hAnioA.toLocaleString()}</li>
                                            <li>Año anterior: {isNaN(hAnioB) ? '-' : hAnioB.toLocaleString()}</li>
                                            <li>Semana actual: {isNaN(hSemA) ? '-' : hSemA.toLocaleString()}</li>
                                            <li>Semana anterior: {isNaN(hSemB) ? '-' : hSemB.toLocaleString()}</li>
                                            <li>Cambio anual: {pct(hAnioA, hAnioB)}</li>
                                            <li>Cambio semanal: {isNaN(hSemA) || isNaN(hSemB) || hSemB === 0 ? '-' : (((hSemA - hSemB) / hSemB * 100).toFixed(1) + '%')}</li>
                                            </ul>
                                        </div>

                                        <div className="col-md-6">
                                            <h6>Personas</h6>
                                            <ul className="list-unstyled">
                                            <li>Año actual: {isNaN(pAnioA) ? '-' : pAnioA.toLocaleString()}</li>
                                            <li>Año anterior: {isNaN(pAnioB) ? '-' : pAnioB.toLocaleString()}</li>
                                            <li>Semana actual: {isNaN(pSemA) ? '-' : pSemA.toLocaleString()}</li>
                                            <li>Semana anterior: {isNaN(pSemB) ? '-' : pSemB.toLocaleString()}</li>
                                            <li>Cambio anual: {pct(pAnioA, pAnioB)}</li>
                                            <li>Cambio semanal: {isNaN(pSemA) || isNaN(pSemB) || pSemB === 0 ? '-' : (((pSemA - pSemB) / pSemB * 100).toFixed(1) + '%')}</li>
                                            </ul>
                                        </div>
                                        </div>
                                    </div>
                                    );
                                })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginBottom: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina ocho</h3>
                            </CardHeader>
                            <CardBody>
                                {(() => {
                                    const d = watch('datosPaginaOcho') || {};
                                    // Accept several possible shapes (array directly, or wrapped under graficaUnoData / rows / data)
                                    const rows = Array.isArray(d)
                                    ? d
                                    : Array.isArray(d.graficaUnoData)
                                    ? d.graficaUnoData
                                    : Array.isArray(d.rows)
                                    ? d.rows
                                    : Array.isArray(d.data)
                                    ? d.data
                                    : Array.isArray(d.barrios)
                                    ? d.barrios
                                    : [];

                                    // Normalizer for numeric fields
                                    const toNum = (v) => {
                                    if (v === undefined || v === null || v === '') return 0;
                                    const s = String(v).replace(/[^\d.-]/g, '');
                                    return s === '' ? 0 : Number(s);
                                    };

                                    // Compute totals
                                    const totalHogares = rows.reduce((s, r) => s + toNum(r.hogares_count ?? r.hogares ?? r.total_hogares ?? r.totalHogar), 0);
                                    const totalPersonas = rows.reduce((s, r) => s + toNum(r.total_personas ?? r.personas ?? r.total_personas_atendidas ?? r.total_personas_atendidas), 0);

                                    // Optionally sort by hogares_count descending for readability
                                    const sorted = [...rows].sort((a, b) => (toNum(b.hogares_count ?? b.hogares) - toNum(a.hogares_count ?? a.hogares)));

                                    return (
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                        <div>
                                            <strong>Registros:</strong> {rows.length}
                                            &nbsp;&nbsp;
                                            <strong>Total Hogares:</strong> {totalHogares.toLocaleString()}
                                            &nbsp;&nbsp;
                                            <strong>Total Personas:</strong> {totalPersonas.toLocaleString()}
                                        </div>
                                        </div>

                                        {rows.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table table-sm table-striped">
                                            <thead>
                                                <tr>
                                                <th style={{ minWidth: 140 }}>Comuna</th>
                                                <th style={{ minWidth: 220 }}>Barrio</th>
                                                <th style={{ textAlign: 'right', minWidth: 120 }}>Hogares</th>
                                                <th style={{ textAlign: 'right', minWidth: 120 }}>Personas</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {sorted.map((r, idx) => {
                                                const comuna = r.comuna ?? r.Comuna ?? r.comuna_nombre ?? r.comunaName ?? '-';
                                                const barrio = r.barrio ?? r.Barrio ?? r.nombre_barrio ?? r.barrioName ?? '-';
                                                const hogares = r.hogares_count ?? r.hogares ?? r.total_hogares ?? 0;
                                                const personas = r.total_personas ?? r.personas ?? r.total_personas_atendidas ?? r.total ?? 0;
                                                return (
                                                    <tr key={`${r.id ?? `${comuna}-${barrio}`}-${idx}`}>
                                                    <td>{String(comuna)}</td>
                                                    <td>{String(barrio)}</td>
                                                    <td style={{ textAlign: 'right' }}>{(hogares === '' || hogares === null || typeof hogares === 'undefined') ? '-' : Number(hogares).toLocaleString()}</td>
                                                    <td style={{ textAlign: 'right' }}>{(personas === '' || personas === null || typeof personas === 'undefined') ? '-' : Number(personas).toLocaleString()}</td>
                                                    </tr>
                                                );
                                                })}
                                            </tbody>
                                            </table>
                                        </div>
                                        ) : (
                                        <p>No hay datos para mostrar en la página ocho.</p>
                                        )}
                                    </div>
                                    );
                                })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginTop: 20 }}>
                            <CardHeader>
                            <h3 className="card-title">Datos pagina ocho diferenciales</h3>
                            </CardHeader>
                            <CardBody>
                            {(() => {
                                const d = watch('datosPaginaOchoB') || {};
                                console.log('Datos página seis diferenciales:', d);
                                const graf1 = Array.isArray(d.graficaUnoData)
                                ? d.graficaUnoData
                                : [];

                                const graf2 = Array.isArray(d.graficaDosData)
                                ? d.graficaDosData
                                : [];

                                const graf3 = Array.isArray(d.graficaTresData)
                                ? d.graficaTresData
                                : [];

                                const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return 0;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? 0 : Number(s);
                                };

                                const total1 = graf1.reduce((acc, r) => acc + toNum(r.total), 0);

                                const pct = (val, tot) => {
                                if (tot === 0) return '-';
                                return ((toNum(val) / tot) * 100).toFixed(1) + '%';
                                };

                                return (
                                <div>
                                    <div className="form-group">
                                    <label>Texto Cualitativo 1</label>
                                    <textarea
                                        className="form-control"
                                        rows={2}
                                        {...register('datosPaginaOchoB.textoCualitativo')}
                                        placeholder="Ej: 53.7% de las personas atendidas provenientes de otros municipios fueron mujeres."
                                    />
                                    </div>

                                    <div className="form-group">
                                    <label>Texto Cualitativo 2</label>
                                    <textarea
                                        className="form-control"
                                        rows={2}
                                        {...register('datosPaginaOchoB.textoCualitativoDos')}
                                        placeholder="Ej: Los NNAJ con edades entre los 0 y los 17 años..."
                                    />
                                    </div>

                                    <div className="form-group">
                                    <label>Texto Cualitativo 3</label>
                                    <textarea
                                        className="form-control"
                                        rows={2}
                                        {...register('datosPaginaOchoB.textoCualitativoTres')}
                                        placeholder="Ej: Las personas de edades entre los 26 a 59 años..."
                                    />
                                    </div>

                                    <div className="form-group">
                                    <label>Texto Cualitativo 4</label>
                                    <textarea
                                        className="form-control"
                                        rows={2}
                                        {...register('datosPaginaOchoB.textoCualitativoCuatro')}
                                        placeholder="Ej: 1 persona que se reconoció como población OSIEGD fue atendida."
                                    />
                                    </div>

                                    <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                                    <div style={{ flex: 1 }}>
                                        <h6>Gráfica 1 — Personas por Sexo</h6>
                                        {graf1.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table table-sm table-striped">
                                            <thead>
                                                <tr>
                                                <th>Sexo</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                <th style={{ textAlign: 'right' }}>%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {graf1
                                                .slice()
                                                .sort((a, b) => toNum(b.total) - toNum(a.total))
                                                .map((r, i) => (
                                                    <tr key={`${r.categoria}-${i}`}>
                                                    <td>{String(r.categoria ?? '-')}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        {toNum(r.total) === 0 ? '-' : toNum(r.total).toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{pct(r.total, total1)}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                <td colSpan={1}><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}><strong>{total1.toLocaleString()}</strong></td>
                                                <td />
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                        ) : (
                                        <p>No hay datos para la gráfica 1.</p>
                                        )}
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <h6>Gráfica 2 — Personas por Grupo Etario y Sexo</h6>
                                        {graf2.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table table-sm table-striped">
                                            <thead>
                                                <tr>
                                                <th>Grupo Etario</th>
                                                <th style={{ textAlign: 'right' }}>Hombres</th>
                                                <th style={{ textAlign: 'right' }}>%Hombres</th>
                                                <th style={{ textAlign: 'right' }}>Mujeres</th>
                                                <th style={{ textAlign: 'right' }}>%Mujeres</th>
                                                <th style={{ textAlign: 'right' }}>Intersexual</th>
                                                <th style={{ textAlign: 'right' }}>%Intersexual</th>
                                                <th style={{ textAlign: 'right' }}>Indefinido</th>
                                                <th style={{ textAlign: 'right' }}>%Indefinido</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {graf2.map((r, i) => {
                                                const h = toNum(r.hombres);
                                                const pctH = toNum(r.porcentajeHombres)
                                                const m = toNum(r.mujeres);
                                                const pctM = toNum(r.porcentajeMujeres)
                                                const inter = toNum(r.intersexual);
                                                const pctInter = toNum(r.porcentajeIntersexual)
                                                const indef = toNum(r.indefinido);
                                                const pctIndef = toNum(r.porcentajeIndefinido)
                                                const rowTotal = h + m + inter + indef;
                                                
                                                const displayLabel = String(r.grupoetareo ?? r.categoria ?? '-')
                                                    .replace('de_', '')
                                                    .replace(/_/g, ' ')
                                                    .replace('anios', 'años')
                                                    .replace('0 mas', '0 o más');

                                                return (
                                                    <tr key={r.grupoetareo ?? r.categoria ?? i}>
                                                    <td>{displayLabel}</td>
                                                    <td style={{ textAlign: 'right' }}>{h || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{pctH || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{m || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{pctM || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{inter || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{pctInter || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{indef || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{pctIndef || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}><strong>{rowTotal}</strong></td>
                                                    </tr>
                                                );
                                                })}
                                                <tr>
                                                <td><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}>
                                                    <strong>{graf2.reduce((acc, r) => acc + toNum(r.hombres), 0)}</strong>
                                                </td>
                                                <td />
                                                <td style={{ textAlign: 'right' }}>
                                                    <strong>{graf2.reduce((acc, r) => acc + toNum(r.mujeres), 0)}</strong>
                                                </td>
                                                <td />
                                                <td style={{ textAlign: 'right' }}>
                                                    <strong>{graf2.reduce((acc, r) => acc + toNum(r.intersexual), 0)}</strong>
                                                </td>
                                                <td />
                                                <td style={{ textAlign: 'right' }}>
                                                    <strong>{graf2.reduce((acc, r) => acc + toNum(r.indefinido), 0)}</strong>
                                                </td>
                                                <td />
                                                <td style={{ textAlign: 'right' }}>
                                                    <strong>
                                                    {graf2.reduce((acc, r) => 
                                                        acc + toNum(r.hombres) + toNum(r.mujeres) + toNum(r.intersexual) + toNum(r.indefinido), 0
                                                    )}
                                                    </strong>
                                                </td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                        ) : (
                                        <p>No hay datos para la gráfica 2.</p>
                                        )}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <h6>Gráfica 3 — Personas por Población OSIEGD</h6>
                                        {graf3.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table table-sm table-striped">
                                            <thead>
                                                <tr>
                                                <th>Población OSIEGD</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                <th style={{ textAlign: 'right' }}>%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {graf3.map((r, i) => (
                                                    <tr key={`${r.categoria}-${i}`}>
                                                    <td>{String(r.categoria ?? '-')}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        {toNum(r.total) === 0 ? '-' : toNum(r.total).toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{pct(r.total, total1)}</td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                <td><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}><strong>{total1.toLocaleString()}</strong></td>
                                                <td />
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                        ) : (
                                        <p>No hay datos para la gráfica 3.</p>
                                        )}
                                      </div>  
                                    </div>
                                </div>
                                );
                            })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginBottom: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina diez</h3>
                            </CardHeader>
                            <CardBody>
                                <div className="form-group">
                                    <label>Resumen (texto)</label>
                                    <textarea
                                        className="form-control"
                                        rows={4}
                                        {...register('datosPaginaDiez.textoResumen')}
                                        placeholder="Ingrese el texto resumen..."
                                    />
                                </div>
                                {(() => {
                                    const d = watch('datosPaginaDiez') || {};
                                    const rows = Array.isArray(d)
                                    ? d
                                    : Array.isArray(d.graficaUnoData)
                                    ? d.graficaUnoData
                                    : Array.isArray(d.rows)
                                    ? d.rows
                                    : Array.isArray(d.data)
                                    ? d.data
                                    : [];

                                    const toNum = (v) => {
                                    if (v === undefined || v === null || v === '') return 0;
                                    const s = String(v).replace(/[^\d.-]/g, '');
                                    return s === '' ? 0 : Number(s);
                                    };

                                    const totalHogares = rows.reduce((s, r) => s + toNum(r.hogares ?? r.hogares_count ?? r.hogares_total), 0);
                                    const totalPersonas = rows.reduce((s, r) => s + toNum(r.personas ?? r.total_personas ?? r.total), 0);

                                    // Sort by hogares descending for readability
                                    const sorted = [...rows].sort((a, b) => toNum(b.hogares ?? b.hogares_count) - toNum(a.hogares ?? a.hogares_count));

                                    return (
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                        <div>
                                            <strong>Registros:</strong> {rows.length}
                                            &nbsp;&nbsp;
                                            <strong>Total Hogares:</strong> {totalHogares.toLocaleString()}
                                            &nbsp;&nbsp;
                                            <strong>Total Personas:</strong> {totalPersonas.toLocaleString()}
                                        </div>
                                        </div>

                                        {rows.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table table-sm table-striped">
                                            <thead>
                                                <tr>
                                                <th style={{ minWidth: 180 }}>Categoría</th>
                                                <th style={{ minWidth: 220 }}>Factor incidencia</th>
                                                <th style={{ textAlign: 'right', minWidth: 120 }}>Hogares</th>
                                                <th style={{ textAlign: 'right', minWidth: 120 }}>Personas</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {sorted.map((r, i) => {
                                                const categoria = r.categoria ?? r.Categoria ?? r.factor ?? '-';
                                                const factor = r.factor_incidencia ?? r.factorIncidencia ?? r.factor ?? '-';
                                                const hogares = r.hogares ?? r.hogares_count ?? r.hogares_total ?? 0;
                                                const personas = r.personas ?? r.total_personas ?? r.total ?? 0;
                                                return (
                                                    <tr key={`${r.id ?? categoria}-${i}`}>
                                                    <td>{String(categoria)}</td>
                                                    <td>{String(factor)}</td>
                                                    <td style={{ textAlign: 'right' }}>{(hogares === '' || hogares === null || typeof hogares === 'undefined') ? '-' : Number(hogares).toLocaleString()}</td>
                                                    <td style={{ textAlign: 'right' }}>{(personas === '' || personas === null || typeof personas === 'undefined') ? '-' : Number(personas).toLocaleString()}</td>
                                                    </tr>
                                                );
                                                })}
                                            </tbody>
                                            </table>
                                        </div>
                                        ) : (
                                        <p>No hay datos para mostrar en la página diez.</p>
                                        )}
                                    </div>
                                    );
                                })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginBottom: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina once</h3>
                            </CardHeader>
                            <CardBody>
                                <div className="form-group">
                                    <label>Subtítulo</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        {...register('datosPaginaOnce.subtitulo')}
                                        placeholder="Ingrese subtítulo..."
                                    />
                                </div>

                                <div className="form-group" style={{ marginTop: 12 }}>
                                    <label>Resumen (texto)</label>
                                    <textarea
                                        className="form-control"
                                        rows={4}
                                        {...register('datosPaginaOnce.textoResumen')}
                                        placeholder="Ingrese el texto resumen..."
                                    />
                                </div>
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginBottom: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina doce</h3>
                            </CardHeader>
                            <CardBody>
                                <div className="form-group">
                                    <label>Subtítulo</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        {...register('datosPaginaDoce.subtitulo')}
                                        placeholder="Ingrese subtítulo..."
                                    />
                                </div>
                                <div className="form-group" style={{ marginTop: 12 }}>
                                    <label>Resumen (texto)</label>
                                    <textarea
                                        className="form-control"
                                        rows={4}
                                        {...register('datosPaginaDoce.textoResumen')}
                                        placeholder="Ingrese el texto resumen..."
                                    />
                                </div>
                            </CardBody>
                        </Card>}
                        {getValues('fechaSemanaActual') && <Card style={{ marginBottom: 20 }}>
                            <CardBody>
                                <button type="submit" className="btn btn-primary">
                                    Guardar Reporte
                                </button>
                            </CardBody>
                        </Card>}
                    </form>
                </div>
                <SweetAlert2 {...swalProps}
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}